export default class GeneralRequest<T> {
    requestId: string
    data: T | null
    context: string

    constructor(data: T | null = null, context: string = '') {
        this.requestId = window.crypto.randomUUID() // Guid
        this.data = data
        this.context = context
    }
}
